import { useState } from 'react'

import ConfirmationPopup from '../popups/ConfirmationPopup/ConfirmationPopup'
import InformationPopup from '../popups/InformationPopup/InformationPopup'
import BackgroundPopup from '../popups/BackgroundPopup/BackgroundPopup'

import popupMessages from '../../const/popupMessages'

import classes from './navBar.module.css'
import SECTIONS from '../../const/sections'
import accordionToOpen from '../../const/accordionToOpen'

import confetti from '../../images/confetti.mp4'
import gift from '../../images/gift.png'
import iHealth from '../../images/iHealth.png'
import iSpace from '../../images/iSpace.png'
import iParking from '../../images/iParking.png'
import iPension from '../../images/iPension.png'
import iFood from '../../images/iFood.png'

function NavBar({ onNavigate, observedModels, setObservedModels }) {
  const [selectedLink, setSelectedLink] = useState(null)
  const [accordionId, setAccordionId] = useState(null)

  const toggleObservedModels = () => {
    if (selectedLink) {
      setObservedModels((prevState) => ({
        ...prevState,
        [selectedLink]: true,
      }))
      onNavigate(selectedLink, accordionId)
      setSelectedLink(null)
    }
  }

  return (
    <>
      {selectedLink && selectedLink !== SECTIONS.IMPORTANT && (
        <>
          <ConfirmationPopup
            onCancel={setSelectedLink}
            onConfirm={toggleObservedModels}
            message1={popupMessages[`${selectedLink}_1`]}
            message2={popupMessages[`${selectedLink}_2`]}
            btn={popupMessages[`${selectedLink}_btn`]}
          />
          <BackgroundPopup onCancel={setSelectedLink} />
        </>
      )}
      {selectedLink && selectedLink === SECTIONS.IMPORTANT && (
        <>
          <InformationPopup
            onCancel={setSelectedLink}
            onConfirm={toggleObservedModels}
            message1={popupMessages[`${selectedLink}_1`]}
            message2={popupMessages[`${selectedLink}_2`]}
            btn={popupMessages[`${selectedLink}_btn`]}
          />
          <BackgroundPopup onCancel={setSelectedLink} />
        </>
      )}
      <div className={classes.main_container}>
        <div className={`${classes.button_1} ${classes.button}`}>
          <video className={classes.video} autoPlay muted loop>
            <source src={confetti} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className={`${classes.overlay_text} c_blue`} dir="rtl">
            <img className={classes.gift} src={gift} alt="gift" />
            <p className={classes.p_bold}>מתרגשים?</p>
            <p>גם</p>
            <p>אנחנו!</p>
          </div>
        </div>
        <button
          className={`${
            observedModels[SECTIONS.HEALTH]
              ? classes.button_selected
              : classes.button_health
          } ${classes.button}`}
          onClick={() => {
            setSelectedLink(SECTIONS.HEALTH)
            setAccordionId(accordionToOpen[SECTIONS.HEALTH])
          }}
        >
          {observedModels[SECTIONS.HEALTH] ? (
            <img src={iHealth} alt="iHealth" />
          ) : (
            '?'
          )}
        </button>
        <button
          className={`${
            observedModels[SECTIONS.PENSION]
              ? classes.button_selected
              : classes.button_pension
          } ${classes.button}`}
          onClick={() => {
            setSelectedLink(SECTIONS.PENSION)
            setAccordionId(accordionToOpen[SECTIONS.PENSION])
          }}
        >
          {observedModels[SECTIONS.PENSION] ? (
            <img src={iPension} alt="iPension" />
          ) : (
            '?'
          )}
        </button>
        <button
          className={`${
            observedModels[SECTIONS.ALL_AROUND]
              ? classes.button_selected
              : classes.button_allAround
          } ${classes.button}`}
          onClick={() => {
            setSelectedLink(SECTIONS.ALL_AROUND)
            setAccordionId(accordionToOpen[SECTIONS.ALL_AROUND])
          }}
        >
          {observedModels[SECTIONS.ALL_AROUND] ? (
            <img src={iParking} alt="iParking" />
          ) : (
            '?'
          )}
        </button>
        <button
          className={`${
            observedModels[SECTIONS.FOOD]
              ? classes.button_selected
              : classes.button_food
          } ${classes.button}`}
          onClick={() => {
            setSelectedLink(SECTIONS.FOOD)
            setAccordionId(accordionToOpen[SECTIONS.FOOD])
          }}
        >
          {observedModels[SECTIONS.FOOD] ? (
            <img src={iFood} alt="iFood" />
          ) : (
            '?'
          )}
        </button>
        <button
          className={`${
            observedModels[SECTIONS.WORKING_IN_SPACE]
              ? classes.button_selected
              : classes.button_workingInSpace
          } ${classes.button}`}
          onClick={() => {
            setSelectedLink(SECTIONS.WORKING_IN_SPACE)
            setAccordionId(accordionToOpen[SECTIONS.WORKING_IN_SPACE])
          }}
        >
          {observedModels[SECTIONS.WORKING_IN_SPACE] ? (
            <img src={iSpace} alt="iSpace" />
          ) : (
            '?'
          )}
        </button>
        <button
          className={`${
            observedModels[SECTIONS.IMPORTANT]
              ? classes.button_selected
              : classes.button_important
          } ${classes.button}`}
          onClick={() => {
            setSelectedLink(SECTIONS.IMPORTANT)
            setAccordionId(accordionToOpen[SECTIONS.IMPORTANT])
            setObservedModels((prevState) => ({
              ...prevState,
              [SECTIONS.IMPORTANT]: true,
            }))
          }}
        >
          {observedModels[SECTIONS.IMPORTANT] ? '!' : '?'}
        </button>
      </div>
    </>
  )
}

export default NavBar
